export const PRISM_ENTER = 'PRISM_ENTER';
export const PRISM_EXIT = 'PRISM_EXIT';
export const SAVE_PRISM_IMAGES = 'SAVE_PRISM_IMAGES';
export const SAVE_MAIN_PRISM_IMAGE = 'SAVE_MAIN_PRISM_IMAGE';
export const CLEAR_PRISM_IMAGES = 'CLEAR_PRISM_IMAGES';

export function enterPrism(entryPageUrl) {
  return {
    type: PRISM_ENTER,
    entryPageUrl
  };
}

export function exitPrism() {
  return {
    type: PRISM_EXIT
  };
}

export const savePrismImages = ({ ...args }) => ({
  type: SAVE_PRISM_IMAGES,
  payload: { ...args }
});

export const savePrismImage = ({ ...args }) => ({
  type: SAVE_MAIN_PRISM_IMAGE,
  payload: { ...args }
});

export function clearPrismImages() {
  return {
    type: CLEAR_PRISM_IMAGES
  };
}
